import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";

export function KpiCard({ label, value, delta, deltaPositive = true, prefix = "", icon: Icon, accent = "blue", testid }) {
  const tone = {
    blue:    "text-[#0055FF]",
    emerald: "text-[#22D3A6]",
    amber:   "text-slate-600",  // amber retired — neutralised
    slate:   "text-slate-500",
  }[accent] || "text-[#0055FF]";
  return (
    <Card className="rounded-xl shadow-soft border-slate-200 hover:border-slate-300 transition-colors duration-200" data-testid={testid}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-2">
          <div className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500 font-medium">{label}</div>
          {Icon && <Icon className={`size-4 ${tone} shrink-0`} strokeWidth={1.6} />}
        </div>
        <div className="mt-4 text-[28px] tracking-tight font-semibold text-slate-900 tabular-nums leading-none">{prefix}{value}</div>
        {delta && (
          <div className={`mt-2.5 inline-flex items-center gap-0.5 text-[11px] font-mono ${deltaPositive ? "text-emerald-600" : "text-rose-600"}`}>
            {deltaPositive ? <ArrowUpRight className="size-3" /> : <ArrowDownRight className="size-3" />} {delta}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export function SectionTitle({ title, subtitle, actions, eyebrow }) {
  return (
    <div className="flex items-end justify-between gap-3 mb-7">
      <div>
        {eyebrow && <div className="text-[11px] uppercase tracking-[0.18em] text-[#0055FF] font-semibold mb-2">{eyebrow}</div>}
        <h1 className="text-2xl sm:text-3xl tracking-tight font-semibold text-slate-900 leading-tight">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-slate-600">{subtitle}</p>}
      </div>
      {actions}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
    billable: "bg-blue-50 text-blue-700 border-blue-200",
    delivered: "bg-slate-100 text-slate-700 border-slate-200",
    rejected: "bg-rose-50 text-rose-700 border-rose-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
    open: "bg-amber-50 text-amber-700 border-amber-200",
    processing: "bg-blue-50 text-blue-700 border-blue-200",
  };
  return <span className={`inline-flex items-center text-[10px] font-medium uppercase tracking-wider rounded-full border px-2 py-0.5 ${map[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>{status}</span>;
}
